import { RouteItem } from '@eastcoal/router/types/route'

import {
  SUPPLY_DEMAND_DETAIL_PAGE_PATH,
  SUPPLY_DEMAND_LIST_PAGE_PATH
} from './constants/path'

export const supplyDemandContentRoute: RouteItem = {
  title: '供需信息',
  hideInMenu: true,
  children: [
    {
      title: '列表',
      path: SUPPLY_DEMAND_LIST_PAGE_PATH,
      Component: () => import('./List')
    },
    {
      title: '文章详情',
      path: SUPPLY_DEMAND_DETAIL_PAGE_PATH,
      Component: () => import('./Detail')
    }
  ]
}
